const eventConfig = {
  title: 'TITLE_BRIARDWEEKEND', // 'TITLE_JHD' or 'TITLE_BRIARDWEEKEND'
  date: '2025-08-23', // date of the event, YYYY-MM-DD
  dateEnd: '2025-08-24', // end of the event, or same day YYYY-MM-DD
  isBriardWeekend: true,
  cost: {
    camping: 4000, // costs for camping
    magazine: 1250, // costs for magazine
    // REMOVE
    // lunchCosts: 1150, // costs for lunch
    // membershipNl: 3750, // costs for membership in the Netherlands
    // membershipOther: 5000, // costs for membership outside the Netherlands
    // campsiteCostsMonday: 3000, // costs for camping on Monday
    // dinnerCosts: 2500, // costs for dinner
  },
  discount: {
    multipleDogs: 500,
    multipleEventsPerDog: 1000,
  },
  events: ['championship', 'selection'], // ['jongehondendag', 'championship', 'selection']
  options: {
    camping: true, // show camping
    dinner: false, // show dinner
    magazine: true, // show magazine
    donation: true, // show donation
  },
};

function generateEvents($t) {
  return [
    {
      name: $t('Jonge hondendag'), // name translated
      keyword: 'jongehondendag', // keyword, don't change this
      date: eventConfig.date, // date, YYYY-MM-DD
      calculationDate: eventConfig.date, // date for validation of age
      discountMultipleDogs: false, // discount for multiple dogs
      showBreederGroup: false, // show breeder group for this event
      choices: [
        {
          title: $t('Do not sign up'), // title translated
          keyword: 'none', // keyword, don't change this
          discountMultipleDogs: false, // applicable for discount for multiple dogs
        },
        {
          keyword: '3tot6', // keyword, don't change this
          min: 3, // minimum age in months
          max: 6, // maximum age in months
          title: $t('3 to 6 months'), // title translated
          cost: 2500, // cost in cents
          hint: '', // additional info
          discountMultipleDogs: false, // applicable for discount for multiple dogs
          documents: [], // text that shows for documents
        },
        {
          keyword: '6tot12',
          min: 6,
          max: 12,
          title: $t('6 to 12 months, including behaviour test'),
          cost: 2500,
          hint: '',
          discountMultipleDogs: false,
          documents: [],
        },
        {
          keyword: '12tot18',
          min: 12,
          max: 18,
          title: $t('12 to 18 months, including behaviour test'),
          cost: 2500,
          hint: '',
          discountMultipleDogs: false,
          documents: [],
        },
        {
          keyword: '18tot24',
          min: 18,
          max: 24,
          title: $t('18 to 24 months, including behaviour test'),
          cost: 2500,
          hint: '',
          discountMultipleDogs: false,
          documents: [],
        },
      ],
    },
    {
      name: $t('Championship clubmatch'),
      keyword: 'championship',
      date: eventConfig.date,
      calculationDate: eventConfig.date,
      discountMultipleDogs: true,
      showBreederGroup: true,
      choices: [
        {
          title: $t('Do not sign up'),
          keyword: 'none',
          discountMultipleDogs: false,
        },
        {
          keyword: 'kampioen',
          min: 15,
          title: $t('Champion class'),
          cost: 4500,
          hint: $t('Copy of championship title must be included. If not enclosed the dog will be entered in open class'),
          discountMultipleDogs: true,
          documents: [$t('Copy championship title for the champion class')],
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'open',
          min: 15,
          title: $t('Open class'),
          cost: 4500,
          discountMultipleDogs: true,
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'gebruikshonden',
          min: 15,
          title: $t('Working class'),
          cost: 4500,
          hint: $t('Copy of statement of the ruling organisation must be included. If not enclosed the dog will be entered in open class'),
          discountMultipleDogs: true,
          documents: [$t('Statement of the ruling organisation for entry in the working class')],
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'veteranen',
          min: 96,
          title: $t('Veteran class'),
          cost: 4500,
          discountMultipleDogs: true,
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'tussen',
          min: 15,
          max: 24,
          title: $t('Intermediate class'),
          cost: 4500,
          discountMultipleDogs: true,
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'fokkers',
          min: 9,
          title: $t('Breeder class'),
          hint: $t('Owner should also be the breeder. If not applicable the dog will be entered in open class'),
          cost: 4500,
          discountMultipleDogs: true,
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'junior',
          min: 9,
          max: 18,
          title: $t('Junior class'),
          cost: 4500,
          discountMultipleDogs: true,
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'puppy',
          min: 6,
          max: 9,
          title: $t('Puppy class'),
          cost: 2500,
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: false,
        },
        {
          keyword: 'jongste_puppy',
          min: 4,
          max: 6,
          title: $t('Youngest puppy class'),
          cost: 2500,
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: false,
        },
      ],
    },
    {
      name: $t('Selection day'),
      date: eventConfig.dateEnd,
      calculationDate: eventConfig.dateEnd,
      keyword: 'selection',
      discountMultipleDogs: false,
      showBreederGroup: false,
      choices: [
        {
          title: $t('Do not sign up'),
          keyword: 'none',
        },
        {
          min: 15,
          title: $t('Selection and behaviour test'),
          cost: 5500,
          keyword: 'selectie',
          has_behaviour_test: false,
          documents: [$t('Pedigree'), $t('Photo of the dog'), $t('CSNB'), $t('HD')],
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: true,
        },
        {
          min: 15,
          title: $t('Selection with accomplished behaviour test'),
          cost: 5500,
          keyword: 'selectie_zonder_gedrag',
          has_behaviour_test: false,
          documents: [$t('Pedigree'), $t('Photo of the dog'), $t('CSNB'), $t('HD'), $t('Behaviour test')],
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: true,
        },
        {
          min: 15,
          title: $t('Evaluation'),
          cost: 4500,
          keyword: 'evaluatie',
          has_behaviour_test: false,
          documents: [$t('Pedigree')],
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: true,
        },
        {
          keyword: 'gedrag',
          min: 15,
          title: $t('Behaviour test'),
          cost: 3500,
          has_behaviour_test: false,
          documents: [$t('Pedigree')],
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: true,
        },
        {
          min: 9,
          max: 18,
          title: $t('Youth class'),
          cost: 4500,
          keyword: 'youth',
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: true,
        },
        {
          min: 6,
          max: 9,
          title: $t('Puppy class'),
          cost: 2500,
          keyword: 'puppy',
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: false,
        },
        {
          keyword: 'jongste_puppy',
          min: 3,
          max: 6,
          title: $t('Youngest puppy class'),
          cost: 2500,
          discountMultipleDogs: false,
          discountMultipleEventsPerDog: false,
        },
      ],
    },
  ].filter(event => eventConfig.events.includes(event.keyword));
}

export default generateEvents;
export { eventConfig };
export { generateEvents };



// WEBPACK FOOTER //
// ./src/events.js